module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/portal/portal.component.html
// module id = ./src/app/portal/portal.component.html
// module chunks = main